// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"a32158f1","108":"e0fc339c","318":"b795dfe5","368":"742389a0","371":"f2ef78eb","423":"b5679367","453":"f4ed70e8","644":"59975194","674":"d53ba9d9","731":"3736d731","773":"6ed8669a","787":"a25f38af","820":"bf5d7775","937":"3a1c9e7b","977":"0442f999"}[chunkId] + ".chunk.js";
};